import React from 'react';

import moment from 'moment';
import PropTypes from 'prop-types';

import { key, mobile } from '@philips-emr/tws-utils';

import { getWeekGrid } from '../calendar-util';

import {
  WeeklyHourColumn,
  WeeklyHourIndicator,
  WeeklyMobileHourColumn,
} from '.';

function WeeklyDesktopCalendar({ grid }) {
  return grid.map((hours) => (
    <WeeklyHourColumn key={key('c-weekly-column')} hours={hours} />
  ));
}

function WeeklyMobileCalendar({ grid, endOfDay, startOfDay }) {
  return grid.map((hours) => (
    <WeeklyMobileHourColumn
      key={key('c-weekly-column')}
      hours={hours}
      endOfDay={endOfDay}
      startOfDay={startOfDay}
    />
  ));
}

function WeeklyCalendar({ date, endOfDay, events, startOfDay }) {
  let calendar = null;
  const weekGrid = getWeekGrid(date, startOfDay, endOfDay, events);

  if (mobile.isMobile()) {
    calendar = (
      <WeeklyMobileCalendar
        grid={weekGrid}
        endOfDay={endOfDay}
        startOfDay={startOfDay}
      />
    );
  } else {
    calendar = <WeeklyDesktopCalendar grid={weekGrid} />;
  }

  return (
    <React.Fragment>
      {calendar}
      <WeeklyHourIndicator endOfDay={endOfDay} startOfDay={startOfDay} />
    </React.Fragment>
  );
}

WeeklyCalendar.propTypes = {
  date: PropTypes.oneOfType([PropTypes.instanceOf(moment), PropTypes.string]),

  endOfDay: PropTypes.number,

  events: PropTypes.arrayOf(PropTypes.object),

  startOfDay: PropTypes.number,
};

export default WeeklyCalendar;
